import Config from '@config';
import useCustomer from '@hooks/useCustomer';
import useCart from '@hooks/useCart';

const CheckoutHelper = () => {
  const { cart } = useCart();
  const { customer } = useCustomer();
  let firstName = cart?.deliveryAddress?.firstName || customer?.firstName || '';
  if (firstName.toLowerCase() === 'anonymous') firstName = '';
  const lastName = cart?.deliveryAddress?.lastName || customer?.lastName || '';
  const email = cart?.deliveryAddress?.email || customer?.email || '';
  const cellphone = cart?.deliveryAddress?.cellphone || customer?.defaultShippingAddress?.cellphone || '';
  const line2 = cart?.deliveryAddress?.line2 || customer?.defaultShippingAddress?.line2 || '';
  const companyName = cart?.deliveryAddress?.companyName || customer?.defaultShippingAddress?.companyName || '';

  const showFirstAndLastNameInputs =
    (cart?.deliveryModeCode === Config.PICKUP_IN_STORE && customer?.isAnonymous) ||
    cart?.deliveryModeCode === Config.HOME_DELIVERY;

  const isCompletedContactInfo = !!(showFirstAndLastNameInputs
    ? firstName && lastName && email && cellphone
    : email && cellphone);

  return {
    firstName,
    lastName,
    email,
    cellphone,
    line2,
    companyName,
    showFirstAndLastNameInputs,
    isCompletedContactInfo,
  };
};

export default CheckoutHelper;
